// extracted by css-extract-rspack-plugin
export default {"icon":"Ls72gidSfewiVY2J","first":"mctEU4rzyFsM8rZU","last":"M60DXApFiQYawp9m","link":"LlE4waU_8gYphvWV"};